import React from 'react';
import { Error } from 'frontend-container/components/Errors/Error';
import { ROUTER_OUTLET_SELECTOR } from 'frontend-container/shared/constants';
import {
  createReactRoot,
  removeReactRoot,
} from 'frontend-container/utils/createReactRoot';
import { registerApplication } from 'single-spa';

import { Errors } from '@ac/web-components';

export const pathname404 = '/404';
export const isError404 = (
  pathname: string = window.location.pathname
): boolean => {
  return pathname?.startsWith(pathname404);
};
export const error404AppName = 'error-404';
export const registerError404 = (): void => {
  registerApplication(
    error404AppName,
    {
      bootstrap: () => Promise.resolve(),
      mount: async () => {
        const root = createReactRoot(ROUTER_OUTLET_SELECTOR);
        root.render(<Error404 />);
      },
      unmount: async () => {
        removeReactRoot(ROUTER_OUTLET_SELECTOR);
      },
    },
    (location: Location) => isError404(location.pathname)
  );
};

export const Error404 = (): JSX.Element => (
  <Error errorType={Errors.error404} />
);
